/**
 * @author kuan
 */

export const ANALYSIS = {
  'upload': {category:'editor_dub', action:'click_upload_record', label:'编辑器_上传录音'},
  'generate': {category:'editor_dub', action:'click_ai_dub', label:'编辑器_智能配音'},

  'uploadVIP': {category:'editor_dub', action:'click_upload_record_vip', label:'编辑器_上传录音vip'},
  'generateVIP': {category:'editor_dub', action:'click_ai_dub_vip', label:'编辑器_智能配音vip'},
}

  export default {
    data () {
      return {
        ANALYSIS
      }
    },

    methods: {
      report (item) {
        if (item.badge) {
          this.$analysis(this.ANALYSIS[item.type + 'VIP']);
        } else {
          this.$analysis(this.ANALYSIS[item.type]);
        }
      }
    }
  }



// WEBPACK FOOTER //
// ./src/components/mixins/analysis/soundRecord.js